import { render, staticRenderFns } from "./TermsDialog.vue?vue&type=template&id=6848ebf5&scoped=true"
import script from "./TermsDialog.vue?vue&type=script&lang=js"
export * from "./TermsDialog.vue?vue&type=script&lang=js"
import style0 from "./TermsDialog.vue?vue&type=style&index=0&id=6848ebf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6848ebf5",
  null
  
)

export default component.exports